module.exports = __webpack_public_path__ + "media/images/noticias/viejas/maqueta_nuevo_edificio-df7eb17290785abaa8fb779245ff2f75.jpg";